import React, {
  useEffect,
  useState,
} from "react";

import style from "./Map.module.css";

import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
} from "react-leaflet";

import {
  LatLngTuple,
} from "leaflet";

import InnerMap from "./InnerMap";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  CompanyType,
  findById,
  selectCompanies,
  selectCompany,
} from "../../../../slices/company/companySlice";

import {
  mapIcons,
} from "../../../../stuffs/MapIcons";

import {
  useHistory,
} from "react-router-dom";

import MarkerClusterGroup from "react-leaflet-markercluster";

import L from "leaflet";

interface MapResizeHandlerProps {
  isVisible: boolean;
}

const MapResizeHandler: React.FC<MapResizeHandlerProps> = ({
  isVisible,
}) => {
  const map = useMap();

  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const timer = setTimeout(() => {
      map.invalidateSize();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [isVisible, map]);

  return null;
};

interface MyMapProps {
  isDetailsMode?: boolean;
  onOpenDetails?: () => void;
  isVisible?: boolean;
}

const MyMap: React.FC<MyMapProps> = ({
  isDetailsMode = false,
  onOpenDetails,
  isVisible = true,
}) => {
  const history = useHistory();

  const dispatch = useDispatch();

  const [
    selectedMarkerId,
    setSelectedMarkerId,
  ] = useState<string | null>(
    null
  );

  const coordinates: LatLngTuple = [
    52.36322,
    19.13884,
  ];

  const zoom: number = 6;

  const companies: CompanyType[] =
    useSelector(
      selectCompanies
    );

  const company =
    useSelector(
      selectCompany
    );

  const currentCompanies: CompanyType[] =
    isDetailsMode && company
      ? [company]
      : companies;

  const renderMarkers = () =>
    currentCompanies.map(
      (
        offer: CompanyType,
        index
      ) => (
        <Marker
          key={
            offer._id || index
          }
          position={
            offer.coordinates
          }
          icon={
            mapIcons[
              `${offer.mainField[0]}`
            ]
          }
          eventHandlers={{
            mouseover: (e) => {
              const el =
                e.target._icon;

              if (el) {
                el.classList.add(
                  style.markerHover
                );
              }

              e.target.openPopup();
            },

            mouseout: (e) => {
              const el =
                e.target._icon;

              if (el) {
                el.classList.remove(
                  style.markerHover
                );
              }

              setTimeout(() => {
                e.target.closePopup();
              }, 150);
            },

            click: (e) => {
              const offerId =
                `${offer._id}`;

              if (
                selectedMarkerId ===
                offerId
              ) {
                dispatch(
                  findById(offerId)
                );

                onOpenDetails?.();

                history.push(
                  `/offer/${offerId}`
                );

                return;
              }

              setSelectedMarkerId(
                offerId
              );

              e.target.openPopup();
            },
          }}
        >
          <Popup
            closeButton={false}
            autoClose={false}
          >
            <div
              className={
                style.Name
              }
            >
              {offer.name}
            </div>

            <div
              className={
                style.Row
              }
            >
              {offer.city},{" "}
              {offer.street}{" "}
              {offer.streetNumber}.
            </div>
          </Popup>
        </Marker>
      )
    );

  const createClusterCustomIcon =
    (cluster: any) => {
      return L.divIcon({
        html: `
          <div class="${style.clusterIcon}">
            ${cluster.getChildCount()}
          </div>
        `,
        className: "",
        iconSize: [54, 44],
        iconAnchor: [27, 22],
      });
    };

  return (
    <MapContainer
      className={
        style.Content
      }
      center={coordinates}
      zoom={zoom}
    >
      <MapResizeHandler
        isVisible={isVisible}
      />

      <InnerMap />

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />

      {isDetailsMode ? (
        renderMarkers()
      ) : (
        <MarkerClusterGroup
          showCoverageOnHover={
            false
          }
          spiderfyOnMaxZoom={
            true
          }
          zoomToBoundsOnClick={
            true
          }
          iconCreateFunction={
            createClusterCustomIcon
          }
        >
          {renderMarkers()}
        </MarkerClusterGroup>
      )}
    </MapContainer>
  );
};

export default MyMap;